import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, personalInfo, REQUIRED } from "./utils";
import * as GEORGIA from "pages/employer-of-record/onboarding/profile-info/form/ge/constants.ge";

export const georgiaFields = {
  geFirstNameGeorgian: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "geFirstNameGeorgian",
    label: "First Name (Georgian)",
    message:
      "Please enter your first name exactly as shown on your Georgian ID, using the Georgian alphabet (Mkhedruli).",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("geFirstNameGeorgian", ""),
  }),
  geLastNameGeorgian: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "geLastNameGeorgian",
    label: "Last Name (Georgian)",
    message:
      "Please enter your last name exactly as shown on your Georgian ID, using the Georgian alphabet (Mkhedruli).",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("geLastNameGeorgian", ""),
  }),
  geIdentityType: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "geIdentityType",
    label: "Identity Type",
    placeholder: "Select identity type",
    options: GEORGIA.IDENTITY_TYPE_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("geIdentityType", ""),
  }),
  gePersonalId: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "gePersonalId",
    label: "Personal ID",
    validations: {
      required: {
        when: {
          geIdentityType: (value) => value === "personal_id",
        },
      },
      text: {
        fn: {
          value: (value) => !value || /^\d+$/.test(String(value)),
          message: "Must contain digits only",
        },
      },
    },
    hideWhen: {
      geIdentityType: (value) => value !== "personal_id",
    },
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("gePersonalId", ""),
  }),
  geForeignId: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "geForeignId",
    label: "Foreign ID",
    validations: {
      required: {
        when: {
          geIdentityType: (value) => value === "foreign_id",
        },
      },
    },
    hideWhen: {
      geIdentityType: (value) => value !== "foreign_id",
    },
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("geForeignId", ""),
  }),
  gePensionScheme: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "gePensionScheme",
    label: "Included in Georgian Mandatory Pension Scheme",
    placeholder: "Select an option",
    message:
      'Select "Yes" if the employee is enrolled in Georgia\'s mandatory funded pension scheme.',
    options: GEORGIA.YES_NO_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("gePensionScheme", ""),
  }),
  geDisabilityStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "geDisabilityStatus",
    label: "Recognized Disability Status (Tax Allowance Eligibility)",
    placeholder: "Select an option",
    message:
      'Select "Yes" if you have officially recognized disability status in Georgia and qualify for related tax allowances.',
    options: GEORGIA.YES_NO_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("geDisabilityStatus", ""),
  }),
  geHighMountainRegion: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "geHighMountainRegion",
    label: "High-Mountain Region Employment Status",
    placeholder: "Select an option",
    message:
      'Select "Yes" if your official workplace is located in a government-designated high-mountain region of Georgia, which may qualify for tax benefits.',
    options: GEORGIA.YES_NO_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("GE"),
    },
    value: personalInfo("geHighMountainRegion", ""),
  }),
};
